"use client"

import type React from "react"
import { AlertCircle } from "lucide-react"
import { Alert, AlertTitle, AlertDescription } from "./alert"
import { Button } from "./button"
import SentryFeedbackButton from "./SentryFeedbackButton"

const SentryFallback: React.FC = () => {
  const handleRefresh = () => {
    window.location.reload()
  }

  return (
    <div className="flex min-h-screen items-center justify-center p-4 bg-gray-50">
      <div className="w-full max-w-md space-y-4">
        <Alert variant="destructive">
          <AlertCircle className="h-5 w-5" />
          <AlertTitle>Something went wrong</AlertTitle>
          <AlertDescription className="mt-2">
            We're sorry, but something unexpected happened. Our team has been notified and is working to fix the issue.
          </AlertDescription>
        </Alert>

        <div className="flex gap-3 justify-end">
          <SentryFeedbackButton />
          <Button variant="default" onClick={handleRefresh}>
            Try Again
          </Button>
        </div>
      </div>
    </div>
  )
}

export default SentryFallback
